import * as RollOffStepResponse from '../../../step-response/roll-off';
import Circuit from './circuit';
import FirstOrderCommonMain from '../common/main';

export default class FirstOrderHighPassMain extends FirstOrderCommonMain {
  algorithm;

  getStepValues(idealStep, circuit, timeAxis) {
    var k = (circuit.r3.value + circuit.r4.value) / circuit.r3.value;
    var result = RollOffStepResponse.getActualStepResponse(idealStep, circuit, timeAxis, k);
    return result;
  }

  createCircuit(stageFp, gain, stageQ, optimization, initialCapacitorValue) {
    var result = Circuit.create({
      algorithm: this.algorithm,
      stageFp: stageFp,
      gain: gain,
      stageQ: stageQ,
      optimization: optimization,
      initialCapacitorValue: initialCapacitorValue,
    });
    return result;
  }
}
